import { Box, Separator, Stack } from "@chakra-ui/react";
import PricingFooter from "@/components/pricingFooter";
import { FOOTER_CONSTANTS } from "./constants";
import SecurityComplianceTable from "./securityBundles";
import MicrosoftServicesTable from "./servicesBundles";

const M365Table = () => {
  return (
    <Stack gap={8}>
      <Box mb={8}>
        <SecurityComplianceTable />
      </Box>
      <MicrosoftServicesTable />
      <PricingFooter {...FOOTER_CONSTANTS} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Stack>
  );
};
export default M365Table;
